import React from 'react';
import { Heart } from './icons_svg';
import { trackClick, trackListTracEvent } from "./util";

export default class Toggle extends React.Component {

    handleClick = () => {
        let {className, defaultStatus} = this.props;
        // TRACK: modifies "search follows map" (set/unset) / changes map/list view
        if (className === 'map-search-toggle') {
            trackClick('search_form_click', `search-follows-map-toggle: ${!defaultStatus}`)
        }
        if (className === "map-list-toggle") {
            let mapListView = defaultStatus ? 'list' : 'map';
            trackClick('search_form_click', `${className}: ${mapListView}`)
        }
        this.props.callback(!this.props.defaultStatus);
	};

    render() {
        const {onText, offText, className, checkbox, defaultStatus} = this.props;
        const cb = checkbox !== undefined | checkbox;
        return (
            <button
                className={`toggle-button ${className}`}
                onClick={this.handleClick}
            >
                {cb ? <input type="checkbox" checked={defaultStatus} readOnly={true} /> : ""}
                <span className="status-text">{defaultStatus ? onText : offText}</span>
            </button>
        );
    }
}

export class HeartToggle extends React.Component {
    setLikedItem = (itemId, likedState) => {
        const likedList = JSON.parse(window.localStorage.advReLikes || "[]");
        const likedSet = new Set(likedList);
        if (likedState) {
            likedSet.add(itemId);
        } else {
            likedSet.delete(itemId);
        }
        window.localStorage.advReLikes = JSON.stringify(Array.from(likedSet));
    }
    getLikedItem = (itemId) => {
        const likedList = JSON.parse(window.localStorage.advReLikes || "[]");
        const likedSet = new Set(likedList);
        return likedSet.has(itemId);
    }
	render() {
        const {className, adId, clear = true, origin, item, trackingEnabled} = this.props;
        let isLiked = this.getLikedItem(adId);
        const heartClass = isLiked ? "heart-liked" : "";
        const displayClass = clear ? "clear-toggle" : "opaque-toggle";
        return (
            <button
                className={`${displayClass} ${className} ${heartClass}`}
                onClick={(e) => {
                    const el = e.currentTarget;
                    isLiked = !isLiked;
                    if (isLiked) {
                        el.classList.add("heart-liked");
                        // TRACK: fav click
                        trackClick(`${origin}_fav_click`,`liked: ${adId}`);
                        if (origin === 'detail')
                            trackListTracEvent(item, trackingEnabled, 'favorite');
                    } else {
                        el.classList.remove("heart-liked");
                        // TRACK: fav click
                        trackClick(`${origin}_fav_click`,`unliked: ${adId}`);
                    }
                    console.log("Setting " + adId + " to liked=" + isLiked);
                    this.setLikedItem(adId, isLiked)
                    e.stopPropagation();
                }}
            >
                <Heart />
                {!clear && <div className="description">Favorite</div>}
            </button>
	)
	}
}
